import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H12.5C13.3284 0 14 0.671573 14 1.5V2.875H7H0V1.5ZM0 4.125V12.5C0 13.3284 0.671573 14 1.5 14H6.375V4.125H0ZM7.625 4.125V14H12.5C13.3284 14 14 13.3284 14 12.5V4.125H7.625Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }